import type { IconData } from '@stacksjs/iconify-core'

export const erlenmeyerFlask: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3c-3.965 0-7.16.258-9.316.506c-1.45.167-2.11 1.796-1.25 2.976l1.957 2.683a4 4 0 0 1 .737 1.86l.75 6.004a2.03 2.03 0 0 1-.572 1.669C9.814 25.267 6.25 29.973 4.482 32.59c-1.042 1.544-1.496 3.379-1.39 5.239l.013.229c.225 3.698 3.189 6.282 6.886 6.53c3.234.217 7.848.411 14.01.411c6.16 0 10.774-.194 14.009-.411c3.696-.248 6.66-2.832 6.885-6.53l.014-.23c.105-1.86-.35-3.694-1.391-5.238c-1.767-2.618-5.332-7.324-11.824-13.893a2.03 2.03 0 0 1-.572-1.669l.75-6.003a4 4 0 0 1 .737-1.861l1.957-2.683c.86-1.18.201-2.81-1.25-2.976C31.161 3.258 27.965 3 24 3Z\"/><path stroke-linecap=\"round\" d=\"M37 33.762s-1.571-3.143-7.333-8.905\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default erlenmeyerFlask
